import { withStyles } from 'legacyStyles';

import { Button } from 'Components/LegacyButton';

export default withStyles(Button, {
  root: {
    minWidth: 280,
  },
});
